const __WEBPACK_NAMESPACE_OBJECT__ = require("@noble/hashes/sha3");